import React, { Fragment } from "react";

import Accordion from "devextreme-react/accordion";
//devex
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";

// helpers //
import { Case, CaseElse, Switch } from "@app/contexts";
import { useAppSelector } from "@app/state";
import { selectListReportUi_currentListOpsData } from "@app/state/insider/ui/uiList";
import "@app/style/dx.generic.karmaGunMetal.css";
import { ILxReportOption } from "@app/types/insider";

/* -------------------------------------------------------------------------- */
import "./lists_common.scss";
// components //
import {
  ActiveListModelSave,
  ActiveListModelSaveAs,
  AnyListModelDelete,
  CommandHeader,
  InfoGroupHeader,
  OtherListModelSaveAs,
  Selection,
} from "./optionPanels";

type TRelativeToActiveReport =
  | "ITSELF"
  | "OTHER"
  | "GROUP"
  | "NOTHING"
  | "OTHER_NOTHING";
/* -------------------------------------------------------------------------- */
//TODO: #27 refactor readonliness and save:
// don't cheeck names in save/overwrite
// cahnge readonly state of saveas/save a copy
// change readonly state on loading, according to each report type and owner
// TODO: #37 cannot save / overwrite a model created by myself
/* -------------------------------------------------------------------------- */
export const OptionsAccordion = ({
  relativeToActiveReport,
}: {
  relativeToActiveReport: TRelativeToActiveReport;
}) => {
  const theList: Partial<ILxReportOption> = useAppSelector(
    selectListReportUi_currentListOpsData
  );
  const operations = new DataSource({
    sort: ["sortOrder"],
    store: new ArrayStore({
      data: [
        {
          id: 1,
          text: "Modifică modelul curent",
          icon: "save",
          visible_on: ["ITSELF"],
          only_when: (lst: any) => {
            return !lst?.readonly;
          },
          meta: {} as ILxReportOption,
          sortOrder: 10,
        },
        {
          id: 2,
          text: "Crează un model nou pe baza selecției curente",
          visible_on: ["ITSELF"],
          only_when: (lst: any) => {
            return true;
          },
          meta: {} as ILxReportOption,
          sortOrder: 20,
        },
        {
          id: 3,
          text: "Șterge modelul curent",
          visible_on: ["ITSELF"],
          only_when: (lst: any) => {
            return !lst?.readonly;
          },
          meta: {} as ILxReportOption,
          sortOrder: 30,
        },
        {
          id: 4,
          text: "Crează o copie",
          visible_on: ["OTHER"],
          only_when: (lst: any) => true,
          meta: {} as ILxReportOption,
          sortOrder: 20,
        },
        {
          id: 5,
          text: "Șterge modelul",
          visible_on: ["OTHER"],
          only_when: (lst: any) => {
            return !lst?.readonly;
          },
          meta: {} as ILxReportOption,
          sortOrder: 30,
        },
        {
          id: 6,
          text: "Redenumeste modelul",
          visible_on: ["OTHER"],
          only_when: (lst: any) => {
            return !lst?.readonly;
          },
          meta: {} as ILxReportOption,
          sortOrder: 10,
        },
        {
          //THE COMMAND OPTIONS//
          id: 7,
          text: "",
          visible_on: ["ITSELF", "OTHER"],
          only_when: (lst: any) => {
            return true;
          },
          meta: {} as ILxReportOption,
          sortOrder: 0,
        },
        {
          id: 999,
          text: "INFO",
          disabled: true,
          icon: "info",
          visible_on: ["ITSELF", "OTHER", "GROUP", "NOTHING", "OTHER_NOTHING"],
          only_when: (lst: any) => true,
          meta: {} as ILxReportOption,
          sortOrder: 999,
        },
      ],
      key: "id",
    }),
    searchExpr: ["text"],
    filter: [["visible_on", "contains", relativeToActiveReport]],
    postProcess: (data) => {
      // don't render any option if theList is undefined (deleted)
      // filter out logic conditions
      // add meta for easier process
      return data
        .filter((item) => theList?.id && item.only_when(theList))
        .map((item) => {
          return {
            ...item,
            meta: theList || {},
          };
        });
    },
  });

  return (
    <div className="rop-options-group dx-swatch-karmaGunMetal">
      <Accordion
        id={"rop-accordion"}
        width={427}
        dataSource={operations}
        collapsible={false}
        multiple={false}
        animationDuration={300}
        deferRendering={true}
        defaultSelectedItemKeys={[7]}
        itemTitleRender={OperationsAccTitle}
        itemRender={OperationsAccAction}
      />
    </div>
  );
};
const OperationsAccAction = (data: any) => {
  return (
    <Switch value={data.id}>
      <Case when={1}>
        <ActiveListModelSave />
      </Case>
      <Case when={2}>
        <ActiveListModelSaveAs />
      </Case>
      <Case when={3}>
        <AnyListModelDelete list={data.meta} />
      </Case>
      <Case when={4}>
        <OtherListModelSaveAs list={data.meta} operation={"SAVEACOPY"} />
      </Case>
      <Case when={5}>
        <AnyListModelDelete list={data.meta} />
      </Case>
      <Case when={6}>
        <OtherListModelSaveAs list={data.meta} operation={"RENAME"} />
      </Case>
      <Case when={7}>
        <Selection list={data.meta} />
      </Case>
      <CaseElse>
        <Fragment />
      </CaseElse>
    </Switch>
  );
};

const OperationsAccTitle = (data: any) => {
  return (
    <Switch value={data.id}>
      <Case when={7}>
        <CommandHeader list={data.meta} />
      </Case>
      <Case when={999}>
        <InfoGroupHeader />
      </Case>
      <CaseElse>
        <div className="dx-form-group-caption rog-accrd-head">{data.text}</div>
      </CaseElse>
    </Switch>
  );
};
